var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { queryOptions, useMutation, useQuery } from '@tanstack/react-query';
import { DROP_ADD_EVENT, DROP_EDIT_EVENT } from 'root/src/shared/descriptions/endpoints/endpointIds';
import { dareDropClient } from 'root/src/client/v2/common/clients/dareDropClient';
import { useDareDropApi } from 'root/src/client/v2/common/hooks/useDareDropApi';
import { dropEndpointIds } from 'root/src/shared/drops/drops.constants';
import { DEMO_DASHBOARD_RECORD_ID } from 'root/src/shared/demoDashboard/demoDashboard.constants';
import { dropEventMock } from 'root/src/shared/demoDashboard/demoDashboard.mocks';
export function useDropEventQuery(params) {
    const { id, mnemonicId } = params !== null && params !== void 0 ? params : {};
    const dropEventQueryOptions = getDropEventQueryOptions({ id, mnemonicId });
    return useQuery(dropEventQueryOptions);
}
export const SAVE_DROP_EVENT_MUTATION_KEY = ['saveDropEvent'];
export function useSaveDropEventMutation() {
    const { fetcher } = useDareDropApi();
    return useMutation({
        retry: false,
        mutationKey: SAVE_DROP_EVENT_MUTATION_KEY,
        mutationFn: (data) => __awaiter(this, void 0, void 0, function* () {
            const endpointId = data.id
                ? DROP_EDIT_EVENT
                : DROP_ADD_EVENT;
            return fetcher({
                endpointId,
                payload: {
                    dropEventPayload: data,
                    publish: data === null || data === void 0 ? void 0 : data.publish,
                },
            }, true);
        }),
    });
}
export function getDropEventQueryOptions(params) {
    const { id, mnemonicId } = params !== null && params !== void 0 ? params : {};
    return queryOptions({
        enabled: Boolean(id || mnemonicId),
        queryKey: [dropEndpointIds.DROP_GET_EVENT, params],
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            // The demo dashboard (clean `/nova/demo-campaign-dashboard` route) resolves its recordId to the demo
            // sentinel; there is no real drop behind it, so short-circuit to the shared demo drop fixture. This
            // drives the header title and seeds the default dashboard time range to the demo window (no server call).
            if (mnemonicId === DEMO_DASHBOARD_RECORD_ID) {
                return dropEventMock;
            }
            return yield dareDropClient({
                endpointId: dropEndpointIds.DROP_GET_EVENT,
                payload: {
                    id: id,
                    recordId: mnemonicId,
                },
            });
        }),
    });
}
